var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#99AEBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.75H17C18.3261 10.75 19.5979 11.2768 20.5355 12.2145C21.4732 13.1521 22 14.4239 22 15.75V33.25C22 32.2554 21.6049 31.3016 20.9017 30.5983C20.1984 29.8951 19.2446 29.5 18.25 29.5H9.5V10.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 10.75H27C25.6739 10.75 24.4021 11.2768 23.4645 12.2145C22.5268 13.1521 22 14.4239 22 15.75V33.25C22 32.2554 22.3951 31.3016 23.0983 30.5983C23.8016 29.8951 24.7554 29.5 25.75 29.5H34.5V10.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.b37e9bdbd308426037075b5b632949d7.svg";
export { ForwardRef as ReactComponent };